import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PwaLayer } from "@/components/PwaLayer";
import { AuthCallback } from "@/components/AuthCallback";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Parcours from "@/pages/Parcours";
import CoursePlayer from "@/pages/CoursePlayer";
import MapPage from "@/pages/MapPage";
import LiveSessionsPage from "@/pages/LiveSessionsPage";
import ProfilePage from "@/pages/ProfilePage";
import AuthPage from "@/pages/AuthPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import VerifyCertificate from "@/pages/VerifyCertificate";
import AdminPage from "@/pages/AdminPage";
import OnboardingPage from "@/pages/OnboardingPage";
import FoundationPage from "@/pages/FoundationPage";
import RetreatsPage from "@/pages/RetreatsPage";
import TestimonialsPage from "@/pages/TestimonialsPage";

function AppRouter() {
  const location = useLocation();
  // Synchronous check: process session_id from OAuth BEFORE any route renders
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="min-h-screen bg-background noise-overlay">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/parcours" element={<Parcours />} />
        <Route path="/cours/:courseId" element={<CoursePlayer />} />
        <Route path="/carte" element={<MapPage />} />
        <Route path="/sessions-live" element={<LiveSessionsPage />} />
        <Route path="/profil" element={<ProfilePage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/verify/:certId" element={<VerifyCertificate />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/fondation" element={<FoundationPage />} />
        <Route path="/retraites" element={<RetreatsPage />} />
        <Route path="/temoignages" element={<TestimonialsPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <PwaLayer />
        <Toaster position="bottom-right" theme="light" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
